import { useState } from "react"

import { Alert, Grid, Paper, Stack, Tab, Tabs, Typography } from "@mui/material"

import { ACTOR_META, DECIDERS, RULE_TOPICS, RuleTopic } from "./guideContent"
import { ActorChip, BulletList, Card, GuideSection } from "./guideParts"

export function DecidersSection() {
  return (
    <GuideSection
      id="deciders"
      eyebrow="En önemli fikir"
      title="Kim neye karar verir?"
      lead="v2'yi anlamanın kısa yolu bu ayrım: ajan ne söyleneceğine, kod nelerin mümkün olduğuna, api-v2 de gerçek gönderime karar verir. Bir cevap beklenmedik çıktıysa önce hangi tarafın kararı olduğunu bulun."
    >
      <Grid container spacing={2}>
        {DECIDERS.map((decider) => (
          <Grid item xs={12} md={4} key={decider.actor}>
            <Card accent={ACTOR_META[decider.actor].color}>
              <Stack spacing={1} sx={{ mb: 1.5 }}>
                <ActorChip actor={decider.actor} size="medium" />
                <Typography variant="subtitle1" sx={{ fontWeight: 900 }}>
                  {decider.headline}
                </Typography>
                <Typography variant="caption" color="text.secondary">
                  {ACTOR_META[decider.actor].description}
                </Typography>
              </Stack>
              <BulletList items={decider.items} />
            </Card>
          </Grid>
        ))}
      </Grid>
    </GuideSection>
  )
}

function TopicPanel({ topic }: { topic: RuleTopic }) {
  return (
    <Paper variant="outlined" sx={{ p: 3, borderRadius: 2 }}>
      <Typography variant="body1" sx={{ lineHeight: 1.65, mb: 2 }}>
        {topic.lead}
      </Typography>
      <Stack component="ol" spacing={1} sx={{ m: 0, pl: 2.5, mb: 2 }}>
        {topic.steps.map((step) => (
          <Typography
            component="li"
            key={step}
            variant="body2"
            sx={{ lineHeight: 1.55 }}
          >
            {step}
          </Typography>
        ))}
      </Stack>
      <Alert severity="warning">
        <Typography variant="body2">
          <strong>Dikkat: </strong>
          {topic.pitfall}
        </Typography>
      </Alert>
    </Paper>
  )
}

export default function RulesSection() {
  const [topicId, setTopicId] = useState<RuleTopic["id"]>("guidance")
  const topic =
    RULE_TOPICS.find((item) => item.id === topicId) || RULE_TOPICS[0]
  return (
    <GuideSection
      id="rules"
      eyebrow="Tenant'ın ayarları"
      title="Guidance, Skill ve Rol nasıl kullanılır?"
      lead="Tenant'ın panelde yazdıkları üç yoldan ajana ulaşır. Hiçbiri için ayrı bir yapay zekâ kararı yoktur: kod filtreler ve hazırlar, ajan okur ve uygular."
    >
      <Tabs
        value={topicId}
        onChange={(_event, value: RuleTopic["id"]) => setTopicId(value)}
        sx={{ mb: 2 }}
      >
        {RULE_TOPICS.map((item) => (
          <Tab key={item.id} value={item.id} label={item.title} />
        ))}
      </Tabs>
      <TopicPanel topic={topic} />
    </GuideSection>
  )
}
